// extracted by mini-css-extract-plugin
export default {"sidebar":"styles_sidebar__CuNDw","level1":"styles_level1__ojAJq","level2":"styles_level2__sgShf","level3":"styles_level3__NvX2v"};